module.exports = __webpack_public_path__ + "media/images/icon/icons8-Org Unit-c4f8b918562dc148cb3b711f8435511d.png";